import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Container,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import HeroSectionGrey from './HeroSectionGrey'
import MainMarketingButton from '../MainMarketingButton'
import RichText from '../RichText'
import Image from '../Image'
import AnimatedText from '../AnimatedText'
import MobileNumberInput from '../MobileNumberInput/MobileNumberInput'
import { useOnScreen } from '../../utils/dom'
import { useStyles } from './HeroSection.style'
import { replaceBucketUrl } from '../../utils/cms'

const HeroSection = ({
  t,
  bannerCta,
  bannerForm,
  bannerImageUrl,
  description,
  heading,
  // isHeadingXRay,
  homepage = false,
  fullWidth = false,
  useCustomStyles,
  ...rest
}) => {
  const [isAnimate, setIsAnimate] = useState(false)
  const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'))
  const headingRef = useRef(null)
  const isVisible = useOnScreen(headingRef)
  const styles = useCustomStyles
    ? useCustomStyles({
        placeholder: replaceBucketUrl(bannerImageUrl || undefined),
      })
    : useStyles()

  useEffect(() => {
    if (isVisible) {
      setIsAnimate(true)
    }
  }, [isVisible])

  if (!bannerImageUrl && !bannerForm && !bannerCta) {
    return <HeroSectionGrey {...{ heading, t, description }} />
  }

  const url = rest?.bannerImages ? rest?.bannerImages[0]?.bucketUrl : undefined

  return (
    <Container
      maxWidth={fullWidth ? 'xl' : 'lg'}
      className={fullWidth && styles.fullWidth}
    >
      <Grid container className={styles.root} mx="auto" my={0}>
        <Grid
          ref={headingRef}
          item
          xs={12}
          md={5}
          className={styles.textWrapper}
        >
          <Box className={styles.title}>
            {heading && (
              <AnimatedText
                animationType={homepage && !smUp ? 'none' : 'slideUp'}
                variant="h1"
                content={heading}
              />
            )}
          </Box>

          {description?.raw && (
            <Box
              className={isAnimate ? styles.slideUpElement : ' '}
              style={{ animationDelay: '1.5s' }}
            >
              <RichText
                className={styles.description}
                variant="body1"
                document={JSON.parse(description.raw)}
              />
              {bannerForm && bannerForm.description.description && (
                <Typography
                  className={`${styles.description} ${styles.formDescription}`}
                  variant="body1"
                >
                  {bannerForm.description.description}
                </Typography>
              )}
            </Box>
          )}
          {bannerForm && bannerForm.formField && (
            <Box
              className={`${styles.inputWrapper} ${
                isAnimate ? styles.slideUpElement : ' '
              }`}
              style={{ animationDelay: '1.5s' }}
            >
              {bannerForm.formField.fieldType === 'tel' ? (
                <MobileNumberInput
                  id={'hero'}
                  placeholder={bannerForm.formField.placeholderText}
                />
              ) : (
                <TextField
                  placeholder={bannerForm.formField.placeholderText}
                  type={bannerForm.formField.fieldType}
                  fullWidth
                  color="secondary"
                  required
                />
              )}
            </Box>
          )}

          {bannerCta && (
            <Box>
              <MainMarketingButton
                className={isAnimate ? styles.slideUpElement : ' '}
                style={{ animationDelay: '1.7s' }}
                t={t}
                title={bannerCta.text}
                renderAsLink={homepage}
              />
            </Box>
          )}
        </Grid>
        {homepage && <Grid item xs />}
        {bannerImageUrl && (
          <Grid
            item
            xs={12}
            md={5}
            {...(!homepage && { sm: 5 })}
            className={styles.imgWrapper}
          >
            <Box className={styles.bannerImage}>
              <Image file={{ url: url || bannerImageUrl }} title={heading} />
            </Box>
          </Grid>
        )}
      </Grid>
    </Container>
  )
}

export default HeroSection
